export const paymentFrequencyOptions = [
	{
		label: 'Please select',
		value: '',
	},
	{
		label: 'Every week',
		value: 'WEEKLY',
		request: {
			weekly: {
				interval: 1,
			},
		},
	},
	{
		label: 'Every two weeks',
		value: 'TWO_WEEKLY',
		request: {
			weekly: {
				interval: 2,
			},
		},
	},
	{
		label: 'Every three weeks',
		value: 'THREE_WEEKLY',
		request: {
			weekly: {
				interval: 3,
			},
		},
	},
	{
		label: 'Every four weeks',
		value: 'FOUR_WEEKLY',
		request: {
			weekly: {
				interval: 4,
			},
		},
	},
	{
		label: 'Every month',
		value: 'MONTHLY',
		request: {
			monthly: {
				interval: 1,
			},
		},
	},
	{
		label: 'Every two months',
		value: 'TWO_MONTHLY',
		request: {
			monthly: {
				interval: 2,
			},
		},
	},
	{
		label: 'Every three months',
		value: 'THREE_MONTHLY',
		request: {
			monthly: {
				interval: 3,
			},
		},
	},
	{
		label: 'Every six months',
		value: 'SIX_MONTHLY',
		request: {
			monthly: {
				interval: 6,
			},
		},
	},
	{
		label: 'Every year',
		value: 'ANNUALLY',
		request: {
			monthly: {
				interval: 12,
			},
		},
	},
];
